import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { processEntities } from '../entities/entities.bulkload';
import { bulkLoadSuccess } from './bulkload.actions';
import * as BulkloadApi from './bulkload.api';

export const bulkLoadSalesOrders$ = (salesOrderIds) => {
  return BulkloadApi.getBySalesOrderIds(salesOrderIds).pipe(
    mergeMap((response) => {
      const entities = processEntities(response);

      return of(bulkLoadSuccess(entities));
    }),
  );
};

export const bulkLoadFulfillmentPlans$ = (fulfillmentPlanIds) => {
  return BulkloadApi.getByFulfillmentPlanIds(fulfillmentPlanIds).pipe(
    mergeMap((response) => {
      const entities = processEntities(response);

      return of(bulkLoadSuccess(entities));
    }),
  );
};

export const bulkLoadFulfillmentPlanSets$ = (fulfillmentPlanSetIds) => {
  return BulkloadApi.getByFulfillmentPlanSetIds(fulfillmentPlanSetIds).pipe(
    mergeMap((response) => {
      const entities = processEntities(response);

      return of(bulkLoadSuccess(entities));
    }),
  );
};
export const bulkLoadLabelFulfillments$ = (labelFulfillmentIds) => {
  return BulkloadApi.getByLabelFulfillmentIds(labelFulfillmentIds).pipe(
    mergeMap((response) => {
      const entities = processEntities(response);

      return of(bulkLoadSuccess(entities));
    }),
  );
};
